import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import FaqSection from "@/components/feature/FaqSection";
import SubscribeSection from "@/components/feature/SubscribeSection";
import usePageMeta from "@/hooks/usePageMeta";
import { topics } from "@/mocks/topics";
import { faqs } from "@/mocks/faq";
import { siteInfo } from "@/mocks/site";
import Hero from "@/pages/home/components/Hero";
import HotRanking from "@/pages/home/components/HotRanking";
import CategoryFilterSection from "@/pages/home/components/CategoryFilterSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import MethodSection from "@/pages/home/components/MethodSection";

const byDateDesc = [...topics].sort((a, b) => b.date.localeCompare(a.date));
const feature = topics.find((topic) => topic.featured) ?? topics[0];
const latest = byDateDesc.slice(0, 4);
const hotTop = [...topics].sort((a, b) => b.hot - a.hot).slice(0, 8);
const featured = byDateDesc.slice(0, 4);

export default function Home() {
  usePageMeta({
    title: "看料档案 - 事件深挖与起底专区｜内幕细节与背后逻辑梳理",
    description:
      "看料档案专注事件深挖，提供看料黑料深挖式的结构化梳理：商业起底、行业内幕与舆情深挖三大栏目，围绕公开事件的细节、内幕与背后逻辑做多角度分析，帮你看懂热点事件的完整链条。",
    keywords: "看料黑料,看料黑料深挖,看料黑料起底,看料黑料内幕,看料黑料背后,事件深度解析",
    canonicalPath: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: siteInfo.name,
          url: "https://kanliao-archive.example/",
          description: siteInfo.intro,
          potentialAction: {
            "@type": "SearchAction",
            target: "https://kanliao-archive.example/topics?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: siteInfo.name,
          email: siteInfo.email,
          foundingDate: siteInfo.since,
        },
        {
          "@type": "ItemList",
          name: "看料档案深度专题",
          itemListElement: topics.map((topic, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: topic.title,
            url: `https://kanliao-archive.example/topics/${topic.slug}`,
          })),
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: { "@type": "Answer", text: faq.answer },
          })),
        },
      ],
    },
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero feature={feature} latest={latest} />
        <HotRanking topics={hotTop} />
        <CategoryFilterSection topics={topics} />
        <FeaturedSection topics={featured} />
        <MethodSection />
        <div className="bg-background-50">
          <FaqSection faqs={faqs} />
        </div>
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}